import React, { useState } from 'react';
import {
  LoadingStatus,
  toastMessage,
  ToastThemes,
} from '../../../../constants/common';
import { showToast } from '../../../../utils/common.util';
import {
  stringSubstitute,
  ToastMessages,
} from '../../../OnBoarding/Organization/constants/onboarding.constants';
import { TmtStatus } from '../../Constant/Constant';
import CircularLoader from '../../../../atoms/CircularLoader/circular-loader';
import ModalDialog from '../../../../atoms/Modal/ModalDialog';
import DropActionForAttendance from './DropActionForAttendance';
import { GeoTagging } from '../../../../services/geoTagging';
import { getFormattedValues } from '../../../../utils/formatter';

const ModalMapForAttendance = (props) => {
  const {
    checkedItems,
    searchInput,
    currentUserRoleId,
    selectedDate,
    setData,
    attendanceIdPropertiesMap,
    setAttendanceIdPropertiesMap,
  } = props;
  const [showModal, setshowModal] = useState(false);
  const [context, setContext] = useState('');
  const [postActionLoading, setPostActionLoading] = useState(-1);

  const handleApprove = () => {
    setContext('approve');
    setshowModal(true);
  };

  const handleReject = () => {
    setContext('reject');
    setshowModal(true);
  };

  const handleActionBtnClick = (statusCode) => {
    setPostActionLoading(LoadingStatus.Loading);
    new GeoTagging()
      .updateAttendanceStaus(
        {
          statusCode: statusCode,
          attendanceRegisterIds: checkedItems,
        },
        currentUserRoleId
      )
      .then(async () => {
        setPostActionLoading(LoadingStatus.Success);
        await new GeoTagging()
          .listAllRegister(
            currentUserRoleId,
            searchInput,
            getFormattedValues('YYYY-MM-DD', selectedDate[0]),
            getFormattedValues('YYYY-MM-DD', selectedDate[1])
          )
          .then((res) => {
            setData(res);
            const newMap = {};
            res?.forEach((item) => {
              newMap[item.pkId] = {
                empStatusCode: item.fkEmployeeStatusCode?.name,
                mgrStatusCode: item.fkManagerStatusCode?.name,
                hrStatusCode: item.fkFinalStatusCode?.name,
              };
            });
            setAttendanceIdPropertiesMap(newMap);
          })
          .catch((err) => {
            showToast(
              err?.response?.data?.message || 'Something Went Wrong! Try Again',
              ToastThemes.error
            );
          });
        showToast(
          ToastMessages.success.replace(stringSubstitute, toastMessage.update),
          ToastThemes.success
        );
      })
      .catch((err) => {
        setPostActionLoading(LoadingStatus.Failure);
        showToast(err?.response?.data?.message, ToastThemes.error);
      });
  };

  const modalMap = {
    approve: {
      title: 'Approve',
      description: 'Are you sure you want to Approve?',
      primaryAction: 'Approve',
      onClickConfirm: () => handleActionBtnClick(TmtStatus.Approve),
      severity: 'success',
      maxWidth: 'md',
      fullWidth: true,
      actionButtonDisabled: false,
    },
    reject: {
      title: 'Reject',
      description: 'Are you sure you want to Reject?',
      primaryAction: 'Reject',
      onClickConfirm: () => handleActionBtnClick(TmtStatus.Reject),
      severity: 'error',
      maxWidth: 'md',
      fullWidth: true,
      actionButtonDisabled: false,
    },
  };
  return (
    <>
      <CircularLoader show={postActionLoading === LoadingStatus.Loading} />
      <DropActionForAttendance
        checkedItems={checkedItems}
        handleApprove={handleApprove}
        handleReject={handleReject}
        attendanceIdPropertiesMap={attendanceIdPropertiesMap}
      />
      <ModalDialog
        severity={modalMap[context]?.severity}
        title={modalMap[context]?.title}
        listComponent={modalMap[context]?.listComponent}
        description={modalMap[context]?.description}
        primaryAction={modalMap[context]?.primaryAction}
        secondaryAction="Cancel"
        showModal={showModal}
        onClickClose={() => setshowModal(false)}
        onClickConfirm={modalMap[context]?.onClickConfirm}
        maxWidth={modalMap[context]?.maxWidth}
        fullWidth={modalMap[context]?.fullWidth}
        primaryButtonDisabled={modalMap[context]?.actionButtonDisabled}
        lhsActionButton={modalMap[context]?.lhsActionButton}
      />
    </>
  );
};

export default ModalMapForAttendance;
